import { axiosInstance, cmsAxiosInstance } from '../base.api';
import { paths } from '../paths';
import {
  TravelAgencyResponse,
  TravelAgencyParams,
  CreateAgencyCmsAccountParams,
  UpdateAgencyCmsAccountParams,
  TravelAgencyUser
} from '../type/travel-agency.type';

export const createTravelAgency = async (data: TravelAgencyParams): Promise<string> => {
  return axiosInstance.post(paths.travelAgencies(), data).then(response => response.data);
};

export const updateTravelAgency = async (
  id: number,
  data: TravelAgencyParams
): Promise<TravelAgencyResponse> => {
  return axiosInstance
    .put(paths.updateTravelAgency(id), data)
    .then(response => response.data.data[0]);
};

export const deleteTravelAgency = async (id: number): Promise<any> => {
  return axiosInstance.delete(paths.deleteTravelAgency(id)).then(response => response.data.data);
};

export const PAGE_SIZE_TRAVEL_AGENCY = 15;
export const getTravelAgencies = async (
  values: any,
  limit?: number,
  page?: number
): Promise<TravelAgencyResponse[]> => {
  return axiosInstance
    .get(paths.travelAgencies(), {
      params: { ...values, limit, page }
    })
    .then(response => response.data);
};

export const getTravelAgency = async (id: number): Promise<TravelAgencyResponse> => {
  return axiosInstance.get(paths.getTravelAgency(id)).then(response => response.data.data[0]);
};

export const createAgencyCmsAccount = async (
  data: CreateAgencyCmsAccountParams
): Promise<TravelAgencyUser> => {
  return cmsAxiosInstance
    .post(paths.createAgencyCmsAccount(), data)
    .then(response => response.data);
};

export const updateAgencyCmsAccount = async (
  cmsUserId: string,
  data: UpdateAgencyCmsAccountParams
): Promise<TravelAgencyUser> => {
  return cmsAxiosInstance
    .put(paths.updateAgencyCmsAccount(cmsUserId), data)
    .then(response => response.data);
};

export const deleteAgencyCmsAccount = async (cmsUserId: string): Promise<any> => {
  return cmsAxiosInstance
    .delete(paths.updateAgencyCmsAccount(cmsUserId))
    .then(response => response.data);
};
